import {Table as BSTable} from "react-bootstrap";
import {ReactElement} from "react";
import {FormattedMessage} from "react-intl";

export interface TableProps<D extends {id:string}> {
  data?: D[]
  columnRenderers: TableColumns<D>;
  colKeys: string[];
  rowClassResolver?: (d:D) => string|undefined;
  category?: string;
}

export interface TableColumn<D extends {id:string}> {
  renderLabel: (optional?:any) => ReactElement,
  render: (d: D, optional?:any) => ReactElement,
}

export interface TableColumns<D extends {id:string}> {
  [key:string]: TableColumn<D>;
}
function Row<D extends {id:string}>(columns: TableColumns<D>, colKeys:string[], rowClassResolver: undefined | ((d:D) => string|undefined)) {
  return (d: D) => <tr key={d.id} className={rowClassResolver ? rowClassResolver(d) : undefined}>{colKeys.map((ck) => {
    return <td key={ck}>{columns[ck].render(d)}</td>;
  })}</tr>;
}
function Table<D extends {id:string}>(props: TableProps<D>) {
  const {
    data,
    columnRenderers,
    colKeys,
    rowClassResolver,
    category,
  } = props;

  const header = colKeys && colKeys.length && Object.keys(columnRenderers).length ?
      colKeys.map((c) =>
              <th key={c}>{(columnRenderers[c] as TableColumn<D>)?.renderLabel(category)}</th>
      )
      : undefined;
  return <BSTable>
    {header ?
        <thead>
          <tr>{header}</tr>
        </thead>
     : undefined}
    {(data && data.length) ? <tbody>
      {
        data?.map(Row<D>(columnRenderers,colKeys,rowClassResolver))
      }
    </tbody> : <tbody><tr><td colSpan={colKeys.length}><div>
      <FormattedMessage
          defaultMessage="No items to show"
          description="no table data available message"
      />
    </div></td></tr></tbody>}
  </BSTable>;
}
export default Table;
